import { createColumnHelper } from "@tanstack/react-table";

import { emptyString } from "../../constants";
import { UTCToDateFormat } from "../../../../shared";

const columnHelper = createColumnHelper();

//Static headers for data table
export const createIndividualGroupProfileColumns = (cellNameRenderer) => [
  columnHelper.accessor("name", {
    header: () => "STORE NAME",
    cell: cellNameRenderer,
  }),

  columnHelper.accessor("createdAt", {
    header: () => "DATE ACTIVATED",
    cell: (row) => {
      const profile = row.row.original;
      return profile.createdAt
        ? UTCToDateFormat(profile.createdAt)
        : emptyString;
    },
  }),

  columnHelper.accessor("totalResponses", {
    header: () => "TOTAL RESPONSES",
    enableSorting: false,
  }),
];
